import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/algorand_logo_mark_black.svg'


const _withScopeId = n => (_pushScopeId("data-v-18ff54bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "on ", -1))
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Your Votes on ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " has already been claimed", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (!_ctx.hasClaimed)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.localStateBetAlgos), 1),
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("h1", {
          style: _normalizeStyle({color: _ctx.color})
        }, _toDisplayString(_ctx.localState.Team), 5)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("h2", {
          style: _normalizeStyle({color: _ctx.color})
        }, _toDisplayString(_ctx.localState.Team), 5),
        _hoisted_6
      ]))
}